import { browserHistory } from 'react-router'
import HistoryTracker from 'back-forward-history'

import ProjectModel from 'models/ProjectModel'
import ResourceModel from 'models/ResourceModel'
import StoryModel from 'models/StoryModel'
import FacultyModel from 'models/FacultyModel'
import NotFoundModel from 'models/NotFoundModel'

import UiStore from 'stores/UiStore'

import { getFirstURLComponent } from 'utils'

const matchers = [
  [ ProjectModel, () => 'explore', element => `?types=${element.type.slug}` ],
  [ ResourceModel, () => 'resources', () => '' ],
  [ NotFoundModel, () => 'resources', () => '' ],
  [ StoryModel, () => getFirstURLComponent(HistoryTracker.getCurrentPathname()), () => '' ],
  [ FacultyModel, () => 'expertise', () => '' ]
]

export default function closePopout () {
  // What should the close button do? That is the millon dollar question...

  // We always want to send the user to the page with the results listing. How
  // we get there depends on whether or not the user opened the popup from a
  // ResultBox, or opened it directly by loading the full URL in a new tab.

  // When the user navigated from clicking on a ResultBox, we want to delete
  // the popup from browser history. This makes it so hitting the browser
  // back button after closing the popup doesn't reopen the popup.
  const landedOnPopout = HistoryTracker.getKeyForTag('initial popout') === HistoryTracker.firstLocationKey
  if (!HistoryTracker.currentlyOnFirstPage && !landedOnPopout) {
    HistoryTracker.goToLocationWithTag('initial popout', -1)
    return
  }

  // When the user navigated from a direct link, we want to add the results
  // page as a new item in browser history. Hitting the back button *should*
  // reopen the popup in this case.

  const { popoutElement } = UiStore

  for (let matcher of matchers) {
    const [ model, slug, sub ] = matcher

    if (popoutElement instanceof model) {
      browserHistory.push(`/${slug(popoutElement)}${sub(popoutElement)}`)
      return
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/closePopout.js